// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svgicon {
  display: inline-block;
  color: var(--f-svg-color, inherit);
  fill: var(--f-svg-fill, currentColor);
  flex-shrink: 0;
  width: var(--f-svg-width, 1em);
  height: var(--f-svg-height, 1em);
  margin: var(--f-svg-margin, 0);
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.svgicon-font-size {
  font-size: var(--f-svg-font-size);
}
`, "",{"version":3,"sources":["webpack://./../../core/slate-icons/src/native-styles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,uDAAuD;EACvD,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".svgicon {\n  display: inline-block;\n  color: var(--f-svg-color, inherit);\n  fill: var(--f-svg-fill, currentColor);\n  flex-shrink: 0;\n  width: var(--f-svg-width, 1em);\n  height: var(--f-svg-height, 1em);\n  margin: var(--f-svg-margin, 0);\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  user-select: none;\n}\n\n.svgicon-font-size {\n  font-size: var(--f-svg-font-size);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
